import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LottosService } from '../../../services/lottos/lottos.service';
import { environment } from 'src/environments/environment';
import { GlobalsService } from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-main-wrap',
  templateUrl: './main-wrap.component.freeplay.html',
  styleUrls: ['./main-wrap.component.scss']
})
export class MainWrapComponent implements OnInit {
  public landingClass: any;
  public systemClass: string;
  public lottoIdClass: number;
  public subs: Subscription;
  public view = environment.multisite.view;

  constructor(protected _lotto: LottosService, protected _globalsService: GlobalsService) {}

  ngOnInit(): void {
    this.setSystem();
  }

  setSystem(): void {
    if (environment.lottery.lot_id !== 0) {
      this.subs = this._lotto.lottoObservable$.subscribe((lottoObj) => {
        this.lottoIdClass = lottoObj['id'];
      });
    }
    this.systemClass = this._globalsService.getSystem().site;
  }

  get setMainClass() {
    return (this.landingClass = `${this.systemClass} lotto-${this.lottoIdClass}`);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
